var PushNotifications = function() {
    var permissionModalHtml = '\
    <div class="modal fade" id="notifications-modal" tabindex="-1" role="dialog" aria-labelledby="login_modal_label" aria-hidden="true">\
        <div class="modal-dialog">\
            <div class="modal-content new-modal-content">\
                <div class="modal-header">\
                    <h4 class="modal-title" id="login_modal_label">\
                        Θέλεις να λαμβάνεις ειδοποιήσεις για τους αγώνες που έχεις επιλέξει;\
                    </h4>\
                </div>\
                <div class="modal-body">\
                    <div class="row row--border">\
                        <div class="col' + (Generic.mobile ? '' : '-sm') + '-12 text-right">\
                            <button type="button" id="notifications-no-btn" class="btn mr-2" data-dismiss="modal">Όχι</button>\
                            <button type="button" id="notifications-yes-btn" class="btn btn-primary" data-dismiss="modal">Ναι</button>\
                        </div>\
                    </div>\
                </div>\
            </div>\
        </div>\
    </div>';

    var publicVapidKey = 'BIP9tntuXAdgH1RxxfeoxcQbKoa4WMOmtdcWxj015zD6LHz88n0Di2Pn1tjh1fPn_lp61OVC1AkXcU7CCEdaPGs';

    function urlBase64ToUint8Array(base64String) {
        var padding = '='.repeat((4 - base64String.length % 4) % 4);
        var base64 = (base64String + padding)
            .replace(/\-/g, '+')
            .replace(/_/g, '/');

        var rawData = window.atob(base64);
        var outputArray = new Uint8Array(rawData.length);

        for (var i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    };

    function createSubscription() {
        navigator.serviceWorker.register('/service-worker.js');

        return navigator.serviceWorker.ready.then(function(registration) {
            return registration.pushManager.getSubscription().then(function(subscription) {
                if (subscription) {
                    return subscription;
                }
                var convertedVapidKey = urlBase64ToUint8Array(publicVapidKey);
                return registration.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: convertedVapidKey
                }).then(function(subscription) {  // save subscription only when created
                    return Ajax.createSubscription(
                        JSON.stringify(subscription.toJSON()),
                        (res) => {
                            window.localStorage.setItem('pushSubscriptionHash', res.hash);
                        }
                    );
                }, function(exc) {
                    // dont throw exception in case of user blocking permissions through browsers
                    // native prompt, cause we need to continue processing favs in any case
                    if (!exc.toString().includes('denied')) {
                        throw exc;
                    }
                });
            });
        });
    }

    // backpedal function in case smth goes wrong with service worker
    function unregisterServiceWorker() {
        return navigator.serviceWorker.getRegistration().then(function(registration) {
            return registration.unregister();
        });
    }

    return {
        isSupported: function() {
            return 'serviceWorker' in window.navigator && 'PushManager' in window;
        }(),
        userAccepted: function() {
            if (!this.isSupported) {
                return false;
            }
            if (!Generic.jsCookies.hasItem('acceptedPushNotifications')) {
                return false;
            }
            if (Generic.jsCookies.getItem('acceptedPushNotifications') == 'yes') {
                return true;
            }
            return false;
        },
        askForPermission: function(callback) {
            if (!this.isSupported) {
                callback();
                return;
            }
            $('body').append(permissionModalHtml);
            $('#notifications-yes-btn').on('click', function() {
                createSubscription().finally(callback);  // continue processing favs in any case
                Generic.jsCookies.setItem('acceptedPushNotifications', 'yes', 3600 * 24 * 365 * 3);
            });
            $('#notifications-no-btn').on('click', function() {
                Generic.jsCookies.setItem('acceptedPushNotifications', 'no', 3600 * 24 * 365 * 3);
                callback();
            });
            $('#notifications-modal').on('hidden.bs.modal', function() {
                $(this).remove();
                if (!Generic.jsCookies.hasItem('acceptedPushNotifications')) {
                    Generic.jsCookies.setItem('acceptedPushNotifications', 'no', 3600 * 24 * 365 * 3);
                    callback();
                }
            });
            $('#notifications-modal').modal();
        },
    };
}();
